import client from "./client";

export default {
    async getPropertiesSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/properties-summary', filters)));
    },
    async getPaymentsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/payments-summary', filters)));
    },
    async getBillsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/bills-summary', filters)));
    },
    async getTenantsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/tenants-summary', filters)));
    },
    async getBillsPaymentsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/bills-payments-summary', filters)));
    },
    async getVisitorsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/visitors-summary', filters)));
    },
    async getUnitsSummary(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/units-summary', filters)));
    },

    // Reports feature - detailed breakdown endpoints (distinct from the
    // *-summary endpoints above, which only ever return a single scalar
    // or a tiny object). Double parseResponse matches every method above:
    // once to unwrap the axios response, once more to unwrap the
    // Laravel {message, data, status} envelope.
    async getRentRoll(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/reports/rent-roll', filters)));
    },
    async getIncomeExpense(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/reports/income-expense', filters)));
    },
    async getMaintenance(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/reports/maintenance', filters)));
    },
    async getPropertyPerformance(propertyId, filters) {
        return client.parseResponse(client.parseResponse(await client.get(`/reports/property-performance/${propertyId}`, filters)));
    },

    // Export endpoints stream a PDF/CSV blob rather than JSON, so these
    // use a single parseResponse (just unwraps the axios response - a
    // blob has no {message,data,status} envelope to unwrap further),
    // matching tenancy.api.js's downloadTenancyReport / tickets.api.js's
    // downloadTicketHistory.
    async exportRentRoll(filters) {
        return client.parseResponse(await client.get('/reports/rent-roll/export', filters, {responseType: 'blob'}));
    },
    async exportOccupancy(filters) {
        return client.parseResponse(await client.get('/reports/occupancy/export', filters, {responseType: 'blob'}));
    },
    async exportIncomeExpense(filters) {
        return client.parseResponse(await client.get('/reports/income-expense/export', filters, {responseType: 'blob'}));
    },
    async exportMaintenance(filters) {
        return client.parseResponse(await client.get('/reports/maintenance/export', filters, {responseType: 'blob'}));
    },
    async exportPropertyPerformance(propertyId, filters) {
        return client.parseResponse(await client.get(`/reports/property-performance/${propertyId}/export`, filters, {responseType: 'blob'}));
    },
}
